// common
export const commonLang = {
  menu: {
    main: '홈',
    setting: '설정',
    template: '템플릿'
  },

  mxpButtonTitle: {
    co: '확인,취소'
  },

  // date
  week: ['일', '월', '화', '수', '목', '금', '토', '일'],
  year: '년',
  month: '월',
  day: '일',
  hour: '시간',
  min: '분',
  today: '오늘',

  // ui
  logo: 'GS수퍼마켓 모바일 통합운영 시스템',
  login: '로그인',
  notice: '알림',

  // common
  add: '추가',
  alrim: '알림',
  all: '전체',
  backeyMessage: '이전키 한번 더 누르면 종료됩니다.',
  cancel: '취소',
  close: '닫기',
  contents: '내용',
  confirm: '확인',
  count: '개',
  edit: '수정',
  etc: '기타',
  exit: '종료',
  id: '아이디',
  password: '비밀번호',
  list: '목록',
  initialize: '초기화',
  listMore: '목록 더보기',
  loading: '로딩중...',

  more: '더보기',
  move: '이동',
  movePage: '해당 페이지로 이동',
  next: '다음',
  previous: '이전',
  remove: '삭제',
  save: '저장',
  search: '검색',
  send: '전송',
  title: '제목',
  top: 'TOP',

  EMPTY_RESULT: '조회된 데이터가 없습니다.',
  L0001: '더이상 이 창을 열지 않음',

  // system
  M1001: '종료하시겠습니까?',
  M1003: '네트워크가 불안정하거나 사용자가 많습니다. \n잠시 후 다시 사용하세요.!!!!!!!!!',
  M1004: '오류가 발생하였습니다.\n재시도 하시겠습니까?',
  M1006: '다운로드에 실패하였습니다.\n잠시후 다시 시도하시기 바랍니다.',
  M1013: '잠시만 기다려 주세요.',
  M1015: '오류가 발생하였습니다.\n재시도 하시겠습니까?',
  M1016: '로그인 후 일정시간이 경과하여 재로그인이 필요합니다.\n재로그인 하시겠습니까?',
  M1017: '해피콜 시스템 토큰인증에 실패하였습니다.\n관리자에게 문의하십시오.',
  M1018: '오류가 발생하였습니다.\n관리자에게 문의하십시오.',
  M1019: '저장하시겠습니까?',
  M1020: '변경사항을 저장하시겠습니까?',
  M1021: '정말로 삭제하시겠습니까?',
  M1022: '삭제하시겠습니까?',
  M1023: '시스템처리시 장애가 발생하였습니다.\n해피콜에 문의해 주세요.',

  // common
  M2001: '목록이 없습니다.',
  M2002: '관련 데이터가 없습니다.',
  M2004: '검색 결과가 없습니다.',
  M2005: '검색어를 입력해주세요.',
  M2006: '조회된 결과가 없습니다.',
  M2007: '변경된 사항이 저장되지 않습니다.\n이동하시겠습니까?',
  M2008: '시간이 오래 걸릴 수 있습니다.\n발주를 실행하시겠습니까?',
  M2009: '변경된 사항이 없습니다.',
  M2010: '조회 조건 변경 시 발주 데이터가 저장되지 않습니다.',
  M2011: '임시저장 결과를 가져오지 못했습니다.\n해피콜 담당자에게 문의해주세요.',
  M2012: '내용을 작성하세요.',
  M2013: '성공적으로 저장되었습니다.',
  M2014: '내용을 작성하세요.(100자)',
  M2015: '대분류 선택이 올바르지 않습니다.',
  M2016: '조직(분류)을/를 선택하세요.',
  M2017: '조회된 결과가 초기화됩니다.\n변경하시겠습니까?',
  M2018: '목록의 모든 내용이 사라집니다. 진행하시겠습니까?',
  M2019: '필수값이 입력되지 않았습니다. 입력중인 정보가 등록(수정)되지 않습니다. 계속 진행 하시겠습니까?',
  M2020: '현재 인터넷이 끊긴 상태입니다.\n인터넷 연결이 가능한 위치로 이동하시고 다시 시도하세요.',
  M2021: '상품을 검색중입니다. 잠시후 다시 시도하세요.',
  M2022: '총 @건 저장이 완료되었습니다.',
  M2023: '변경된 사항이 저장되지않고\n조회된 결과가 초기화됩니다.\n변경하시겠습니까?',
  M2024: '현재 등록중인 상품은 목록에서 재확인 가능합니다. 이동하시겠습니까',
  M2025: '마스터 다운로드가 취소되었습니다. 다시 다운로드를 완료하시고 업무를 수행하세요.',

  // file
  M0038: '첨부할 수 없는 파일 입니다.',
  M0039: '파일 정보 호출시 오류가 발생하였습니다.',
  M0040: '최대 @M까지 업로드 할 수 있습니다.',
  M0041: '모바일에서 다운로드가 불가능한 파일입니다.\n(exe,com,js 등...)',
  M0042: '모바일에서 조회가 불가능한 첨부파일 입니다.',
  M0043: '최대 @개까지 파일을 첨부할 수 있습니다.',
  M0044: '첨부파일을 삭제하시겠습니까?',
  M0045: '같은 이름의 파일이 이미 첨부되어 있습니다.',
  M0046: '[@] 파일만 첨부 가능합니다.', // "첨부할 수 없는 파일 종류입니다.",
  M0047: '모바일에서 표시할 수 없는 파일입니다.',
  M0048: '첨부파일 조회시 오류가 발생하였습니다.',
  M0049: '통장입금 금액이 0원으로 증빙을 첨부 할 수 없습니다.',
  M0050: '첨부파일 을 삭제하시고 다시 첨부하기 바랍니다.',

  // 발주
  M3001: '최소발주량 미만의 수량은 입력할 수 없습니다.',
  M3002: '최대발주량 초과의 수량은 입력할 수 없습니다.',
  M3003: '발주수량이 발주배수(@)가 아닙니다.',
  // 2016.01.17 추가
  M3004: '발주수량이 재고수량을 초과하였습니다.',

  M3005: '발주수량을 입력하세요.',
  M3006: '발주수량에 숫자만 입력하세요.',
  M3007: '발주수량을 입력하세요.',
  M3008: '발주일자를 선택하세요.',
  M3009: '발주차수를 선택하세요.',
  M3010: '대분류를 선택하세요.',

  M3011: '[@]상품의 최소[@]/최대[@] 환산수량 확인바랍니다.',
  M3012: '환산수량이 @개를 초과하였습니다. 등록하시겠습니까?',
  M3013: '행사를 선택하세요.',
  M3014: '조회된 행사가 없습니다.',
  M3015: '저장할 내용이 없습니다.',
  M3016: '삭제할 내용이 없습니다.',

  M3017: '증분류를 선택하세요.',
  M3018: '@원 금액으로 저장하시겠습니까?',
  M3019: '0원으로는 저장할 수 없습니다.',
  M3020: '조회방법을 선택하세요.',
  M3021: '조회방법을 선택하여 팝업창에서 상품을 선택하세요',
  M3022: '선택할 수 없는 발주차수입니다.',
  M3023: '현재일자의 @차수는 발주 마감되었습니다. 발주 조회만 가능합니다.',
  M3024: '이벤트코드는 숫자로 입력하세요.',
  M3025: '행사코드는 숫자로 입력하세요.',
  M3026: '발주배수에 숫자만 입력하세요.',
  M3027: '매대미등록 상품입니다.(단, 발주는 가능합니다.)',
  M3028: '발주수량이 한정수량의 50%를 초과하였습니다. 발주등록 하시겠습니까?',
  M3029: '카테고리를 선택하세요.',
  M3030: '매대번호는 4자리이상 넣어주세요.',
  M3031: '취합중/완료/마감중 하나를 선택해주세요.',
  M3032: '발주수량이 한정수량을 초과했습니다. 재 입력 바랍니다.',
  M3033: '무상지원되는 상품입니다. 발주단위 확인후 입력바랍니다.\n[@]배수 단위로 입력하세요',
  M3034: '이미 마감되었습니다.',
  M3035: '저장하지 않은 발주Data가 있습니다. 저장하지 않고 진행하시겠습니까?',
  M3036: '추가발주 [@]상품은 이전 발주수량[@]보다 커야 합니다.',
  M3037: '발주가능시간이 초과되어 발주 마감되었습니다.',
  M3038: '여러 대분류를 함께 조회시 시간이 오래걸릴 수 있습니다. 진행하시겠습니까?',
  M3039: '매대번호는 6자리만 입력가능합니다.',
  M3040: '매대번호는 숫자만 입력가능합니다.',
  M3041: '마감된 다차수 발주 상품입니다. 차수확인 후 발주진행 해주세요. ',
  // 상품
  M4001: '상품명을 입력하세요.',
  M4002: '상품명은 2자 이상으로 입력하세요.',
  M4003: '상품코드는 숫자로 입력하세요.',
  M4004: '선택 상품을 삭제하시겠습니까?',
  M4005: '성공적으로 삭제되었습니다.',
  M4006: '삭제할 상품을 선택하세요.',
  M4007: '필요수량을 입력하세요.',
  M4008: '상품을 선택하세요.',
  M4009: '상품코드나 상품명을 입력하세요.',
  M4010: '상품코드를 입력하세요.',

  // search
  M5001: '점포코드를 입력해주세요.',
  M5002: '점포명을 입력해주세요.',

  M6001: '@을(를) 선택하세요.',
  M6002: '마스터 다운로드에 실패했습니다. 다시 시도하세요.',

  // 로케이션
  M7001: '로케이션코드를 입력하세요.',
  M7002: '상품 코드를 입력하세요.',
  M7005: '로케이션 상태가 불가능 입니다.',
  M7006: '로케이션 등록 성공 입니다.',
  M7007: '로케이션 변경 실패 입니다.',

  // 할인상품
  M7101: '제한 수량을 입력 하세요.',
  M7102: '할인 상품 등록 성공 입니다.',
  M7103: '할인 상품 등록 실패 입니다.',
  M7104: '작업 시간을 입력하세요.',
  M7105: '로케이션 코드 입력은 중대형점만 가능합니다.'
}

// acom
export const acomLang = {
  L0001: '시작하기',
  L0002: '핸드폰 인증 요청',
  // L0001 : "로그인",
  // L0002 : "인증번호 발송",
  L0003: '자세히보기',

  L0004: 'PIN 번호 설정',
  L0005: 'PIN 번호 입력',
  L0006: 'PIN 번호 변경',
  L0007: 'PIN 번호 확인',

  M0001: '인증토큰정보 생성시 오류가 발생하였습니다.<br/>관리자에게 문의하십시오.',
  M1001: '설정할 PIN번호를 입력하세요.',
  M1002: 'PIN 번호를 입력하세요.',
  M1003: '현재 PIN 번호를 입력해주세요.',
  M1004: '설정할 PIN번호를 다시 입력하세요',
  M1005: '단말 잠금상태입니다.<br/>잠시후 다시 이용해주세요.',
  M1006: '인증정보 조회 에러',
  M1007: '단말 잠금상태입니다.<br/>@분후 다시 이용해주세요.',
  // M1008 : "PIN 번호가 일치하지 않습니다.<br/>PIN 번호 <b>@</b>회 오류입니다.(최대 @회)",
  M1008: 'PIN 번호 <b>@</b>회 오류입니다.(최대 @회)',
  M1009: 'PIN 번호가 변경되었습니다.',
  M1010: 'PIN 번호(숫자 4자리)를 다시 한번 입력하세요.',
  M1011: 'PIN 번호가 일치 하지 않습니다.',
  M1012: '변경할 PIN 번호를 입력하세요.',
  M1013: '변경할 PIN 번호를 다시 입력하세요.',
  M1014: '이미 등록된 단말기가 있습니다.\n현재 단말기로 변경하시겠습니까?',
  M1015: '최근 사용한 단말기와 현재 단말기만 사용이 가능합니다.\n계속 진행하시겠습니까?',
  M1016: 'PIN 번호 입력이 @회 실패하여\n앱을 종료합니다.',
  M1017: '2글자 이상 검색해주세요.',
  M1018: '양수만 입력가능합니다.',
  M1019: '숫자만 입력가능합니다.',
  M1020: '숫자형태의 소숫점 이하 첫째자리까지 입력가능합니다.',
  M1021: '숫자형태의 소숫점 이하 둘째자리까지 입력가능합니다.',
  M1022: '숫자형태의 소숫점 이하 셋째자리까지 입력가능합니다.'
}

// template
export const templateLang = {
  L0001: '',
  M0001: ''
}

// Barcode
export const barcodeLang = {
  M0001: '바코드를 검색합니다.',
  M0002: '인식에 실패했습니다.<br>바코드를 다시 인식해주세요.'
}

export const installLang = {
  M0001: '설치정보를 갱신합니다.'
}

export const acloLang = {
  M0001: '금액을 입력하세요.',
  M0002: '통화연결을 하시겠습니까?',
  M0003: '금액에 숫자만 입력하세요.',
  M0004: '발주가능금액 내에서 금액을 입력하세요.'
}

export const asalLang = {
  M0001: '업무일지 등록 시간이 아닙니다.\n현재 시간대의 업무일지를 다시 확인해 주세요.',
  M0002: '시차는 최대 @개 선택 가능합니다.\n선택할 시차를 확인해 주세요.',
  M0003: '동일 상품의 동일한 진열기한 상품이 있습니다.\n해당 항목으로 이동하시겠습니까?',
  M0004: '동일 상품의 동일한 진열기한 상품이 있습니다.',
  M0005: '삭제할 리스트를 선택하세요',
  //	M0006 : "신규등록 상품은 저장되지 않습니다.\n선택한 상품을 삭제하시겠습니까?",
  M0006: '선택한 상품을 삭제하시겠습니까?',
  M0007: '을(를) 입력하세요.',
  M0008: '변경사항을 저장하시겠습니까?',
  M0009: '오늘 이후 날짜부터 입력/수정 가능합니다.',
  M0010: '부정확한 상품정보입니다.',
  M0011: '진열기한일을 선택하시기 바랍니다.',
  M0012: '임박재고수량을 입력하시기 바랍니다.',
  M0013: '임박재고수량에는 숫자와 소수점 3자리 숫자까지 입력할 수 있습니다.',
  M0014: '임박재고수량에는 숫자만 입력할 수 있습니다.',
  M0015: '조치내용을 등록하세요.'
}

export const abuyLang = {
  M0001: '요청사유를 입력하세요',
  //	M0002 : "성공적으로 저장되었습니다.",	commonLang.M2013 로 변경함
  M0003: '입고수량 이하 수량을 입력하세요.',
  M0004: '상품코드를 입력하세요.',
  M0005: '상품명을 입력하세요.',
  M0006: '입고일자를 입력하세요.',
  M0007: '상품정보가 없습니다. 상품을 조회하세요.',
  M0008: '클레임수량을 입력하세요',
  M0009: '요청사유를 입력하세요',
  M0010: '첨부파일을 입력하세요',
  M0011: '해당 상품의 대분류코드에서는 선택할 수 없는 클레임유형을 선택하셨습니다.',
  M0012: '선도저하, 진열기한 오류선택시 이미지 등록은 필수사항 입니다',
  M0013: '해당일자의 클레임이 이미 마감 되었습니다.',
  M0014: '클레임유형을 선택하세요.',
  M0015: '해당 입고일자에 조회된 상품이 없습니다.',
  M0016: "'@'는 사용할 수 없는 단어입니다.",

  /* 매입등록수정 */
  M0017: '현재일 이후의 일자는 입력할 수 없습니다.',
  M0018: '현재 매입집계 작업 중입니다. 전일자 매입조회는 06시 이후 가능합니다.',
  M0019: '매입일자는(은) 필수입력항목입니다.',
  M0020: '발주구분는(은) 필수입력항목입니다.',
  M0021: '상품의 매입형태가 맞지 않습니다.',
  M0022: '상품상태가 발주금지입니다.',
  M0023: '상품상태가 삭제입니다.',
  M0024: '상품상태가 판매금지입니다.',
  M0025: '동일상품의 중복등록은 불가합니다.',
  M0026: '해당 종량제 거래처는 마스타가 상이하여 등록할 수 없습니다.\n해당 OFC 님에게 확인 요청해주세요.',
  M0027: '해당 담배 거래처는 마스타가 상이하여 등록할 수 없습니다.\n해당 OFC 님에게 확인 요청해주세요.',
  M0028: '입력하신 사업자번호가 마스터상 사업자 번호가 다릅니다.\n확인 후 등록 바랍니다.',
  M0029: '상품코드(xxxx)외 0건의 상품코드는 이미 등록되어있습니다.',
  M0030: '00시부터 04시까지는 저장이 불가합니다.',
  M0031: '신규입고수량(은)는 0보다 커야 합니다.',
  M0032: '입고수량은 0보다 크거나 같아야 합니다.',
  M0033: '입고수량은 예정수량 보다 클 수 없습니다.',
  M0034: '현금매입상품은 증빙유형을 선택해야 합니다.',
  M0035: '현재일 이후의 일자는 입력할 수 없습니다.',
  M0036: '시작일자가 종료일자보다 큽니다.',
  M0037: '종료일자는 시작일자 보다 작을 수 없습니다.',
  M0038: '현재 매입집계 작업 중입니다. 전일자 매입조회는 06시 이후 가능합니다.',
  M0071: '점포직납협력사가 아닙니다.',
  M2001: '상품 등록을 할 수 없습니다.',
  M2002: '이미 등록된 상품이 있습니다.\n해당 상품으로 이동하시겠습니까?',
  M2003: '서버에 이미 저장된 상품입니다. \n조회 후 수정하시거나, 등록팝업에서 상품 스캔 후 수정하세요.',
  M2004: '등록중인 동일한 상품이 있습니다.\n해당 상품으로 이동하시겠습니까?',
  M2005: '목록에 상품이 존재하지 않습니다.',
  M2006: '현금매입의 상품의 증빙유형은 저장하면 수정불가능합니다.',
  M2007: '오늘자에만 등록 가능합니다.',
  M2008: '입고수량을 입력해주세요.',
  M2009: '변경된 내용이 없습니다.',
  M2010: '입고수량이 1000개를 초과했습니다.등록하시겠습니까?',
  M2011: '매입형태가 존재하지 않는 상품입니다.',
  M2012: '상품이 존재하지 않습니다.',
  M2013: '사업자번호를 입력해주세요.',
  M2014: '확정수량은 이동수량보다 작거나 같아야 합니다.',
  M2015: '서버에 이미 저장된 상품입니다. 조회후 수정하세요',

  /* 점간이동등록 */
  M0039: '원가가 매가의 30%이하입니다.\n계속 진행하시겠습니까?',
  M0040: '현재일 이후만 가능합니다.',
  M0041: '이동일자 시작일은 이동일자 종료일 이전이어야 합니다.',
  M0042: '신규의 경우 이동시작일자와 종료일자가 같아야 합니다.',
  M0043: '이동수량이 1000개를 초과했습니다.등록하시겠습니까?',
  M0044: '[축산물 이력제] 대상 상품은 이력(묶음)번호를 입력하셔야 됩니다.',
  M0045: '[축산물 이력제] 대상 상품의 이력(묶음)번호는 숫자만 입력하셔야 됩니다.',
  M0046: '[축산물 이력제] 대상 상품의 이력(묶음)번호는 xx 자리까지만 입력하셔야 됩니다.',
  M0047: '팩 상품은 이동 불가능합니다.',
  M0048: '매입형태가 직납인 주류상품은 이동 불가능합니다.',
  M0049: '동일점포간 이동은 불가합니다.',
  M0050: '입고사업장의 거래형태가 다릅니다. 확인하시기 바랍니다.',
  M0051: '축산 원물 상품은 소형점으로 점간이동 할 수 없습니다.',
  M0052: '특 B 상품은 이동 할 수 없습니다.',
  M0053: '주류상품은 이동할 수 없습니다.',
  M0054: '선매입상품은 이동할 수 없습니다.',
  M0055: '21 대분류 상품은 이관하실 수 없습니다.',
  M0056: '쓰레기봉투(6601) 소분류 상품은 이관 불가합니다.',
  M0057: '담배(1565) 중분류 상품은 이관 불가합니다.',
  M0058: '시작일자가 종료일자보다 큽니다.',
  M0059: '종료일자는 시작일자 이후여야 합니다.',

  M3001: '이동수량을 입력해주세요.',
  M3002: '확정수량을 입력해주세요.',
  M3003: '원가를 입력해주세요.',
  M3004: '매가를 입력해주세요.',
  M3005: '이력번호를 입력해주세요.',
  M3006: '선택된 항목이 없습니다.',
  M3007: '해당일자가 이미 마감 되었습니다. 확인하시기 바랍니다.',
  M3008: '저장하시겠습니까?',
  M3009: '[축산물 이력제] 대상 상품은 이력(묶음)번호를 입력해주세요.',
  M3010: '받는 점포를 입력해주세요.',

  /* 할인스티커 발행 */
  M0060: '등록된 사번이 아닙니다. 발행 권한을 확인하시기 바랍니다.',
  M0061: '등록자를 입력하세요.',
  M0062: '등록일자가 오늘인 경우만 신규 등록이 가능합니다.',
  M0063: '발행 수량은 100건 이하로 입력 하세요!.',
  M0064: '할인율/할인금액이 POS매가보다 크거나 같을 수 없습니다.',
  M0065:
    '할인금액은 100,000원 이하로 입력가능 합니다.\n100,000원 이상의 금액은 할인율을 입력하세요.\n할인금액을(를) 확인하세요.',
  M0066: '재발행시 할인율/할인금액은 이미 발행한 할인율/할인금액보다 크거나 같아야 합니다.',
  M0067: '최대할인율 @% 초과',
  M0068: '최대 할인 @원 입니다.',
  M0069: '재발행수량은 이미 발행한 수량보다 같거나 작아야 합니다.',
  M0070: '등록자를 입력하세요.',
  M0071: '숫자만 입력하세요.',
  M0072: '할인매가를 입력하세요.',
  M0073: '할인율/금액을 입력하세요.',
  M0074: '발행수량을 입력하세요.',
  M0075: '사유를 선택하세요.',
  M0076: '할인매가가 POS매가보다 크거나 같을 수 없습니다.',
  M0077: '사유일괄변경할 건이 없습니다.',
  M0078: '할인금액은 100원 이상 입력 하세요!.',

  /* 임박상품등록 */
  M0079: '판매 가능수량을 입력하세요.',
  M0080: '판매시작일시를 입력하세요.',
  M0081: '판매종료일시를 입력하세요.',
  M0082: '마감할인상품 제외 대상 상품입니다.',
  M0083: '마감할인상품 대상 점포를 확인 해주세요.',
  M0084: '마감할인상품 판매종료일시는 시작일시보다 작을 수 없습니다.',
  M0085: '할인금액 원 단위는 지정 할수 없습니다.',
  M0086: '최대 판매 가능기간은 14일 입니다.',
  M0087: '해당 점포는 폐점처리된 점포입니다. 계속 진행하시겠습니까?',
  M0088: '스티커 할인수량을 입력하세요.'
}

export const aordLang = {
  M0001: '매대번호는 4자리이상 넣어주세요.',
  M0002: '@을(를) 입력하세요.',
  M0003: '최소[@]/최대[@] 발주수량 확인바랍니다.  ',
  M0004: '발주수량이 @개를 초과하였습니다. 등록하시겠습니까? ',
  M0005: '선택하신 날짜의 시황등록정보가 없습니다.\n전일 시황등록기준으로 상품만 조회됩니다. 조회하시겠습니까?',
  M0006: '무상지원되는 상품입니다. 발주단위 확인후 입력바랍니다.  @ 배수 단위로 입력해주세요',
  M0007: '한정수량을 초과했습니다. 재 입력 바랍니다.',
  M0008: '취합중/완료/마감중 하나이상을 선택해주세요.',
  /* 안전재고 */
  M0101: '대분류를 선택하세요',
  M0102: '방식은 필수값입니다. 선택하시고 저장하세요.',
  M0103: '일수/수량은 필수값입니다. 입력하시고 저장하세요.',
  M0104: '일수 선택시 Face당수량은 필수값입니다.\n입력하시고 저장하세요.',
  M0105: '필수값이 입력되지 않았습니다. 입력중인 정보가 등록(수정)되지 않습니다.\n계속 진행 하시겠습니까?',
  M0106: '확정기준수량 [자동확정기준수량]을 초과하였습니다.  수정 입력 바랍니다.',
  M0107: '세분류를 선택하세요',
  M0108: '이미 등록된 상품이 있습니다.\n해당 상품으로 이동하시겠습니까?',
  M0109: '등록중인 동일한 상품이 있습니다.\n해당 상품으로 이동하시겠습니까?',
  M0110: '서버에 이미 저장된 상품입니다. \n조회 후 수정하시거나, 등록팝업에서 상품 스캔 후 수정하세요.'
}

export const amstLang = {
  /* 점포매대 */
  M0001: '카테고리을(를) 선택하세요.',
  M0002: '매대을(를) 선택하세요.',
  M0003: '선반을(를) 선택하세요.',
  M0004: '삭제하시겠습니까?',

  M0008: '변경된 내용이 없습니다.',
  M0009: '저장할 내용이 없습니다.',
  M0010: '매대선반을 추가하시겠습니까?',
  M0011: '동일 매대에 같은 상품이 존재합니다.',
  M0012: '행사매대 일경우에는 적용시작일과 종료일을 입력하세요.',
  M0013: '행사매대 적용일자 범위는 1개월(31일)을 초과 할 수 없습니다.',
  M0014: '가매대 적용일자 범위는 1일을 초과 할 수 없습니다.',
  M0015: 'PB상품 또는 전월 AB군 상품 @건은 발주제외매대에 등록할수 없습니다.',
  M0016: '플라노그램매대상품은 삭제할 수 없습니다.',
  M0017: '무전산상품/특B상품은 89매대에 등록 할 수 없습니다.',
  M0018: '매대대분류와 일치하지 않는 타대분류상품입니다.',
  /* M0019 : "해당 매대는 08-29대분류 상품만 등록가능합니다.",
M0020 : "해당 매대는 07,12대분류 상품만 등록가능합니다.",
M0021 : "해당 매대는 13대분류 상품만 등록가능합니다.",
M0022 : "해당 매대는 27,31대분류 상품만 등록가능합니다.",
M0023 : "50/51매대에 1~7대분류 상품은 등록 하실수 없습니다.", */
  M0019: '해당 매대는 2,4,9,10,11,12,13,14,15,16,17,18 대분류 상품만 등록가능합니다.',
  M0020: '해당 매대는 1,3,14,19 대분류 상품만 등록가능합니다.',
  M0021: '해당 매대는 13,15 대분류 상품만 등록가능합니다.',
  M0022: '해당 매대는 15,18,21 대분류 상품만 등록가능합니다.',
  M0023: '50/51매대에 1,3,5,6,7,8,19 대분류 상품은 등록 하실수 없습니다.',
  M0024: '시작/종료일을 입력하세요.',
  M0025: '종료일이 시작일보다 이전입니다.',
  M0026: '행사매대 적용일자 범위는 1개월(31일)을 초과 할 수 없습니다.',
  M0027: '가매대 적용일자 범위는 1일을 초과 할 수 없습니다.',

  M0032: '89매대 적용일자 범위는 100일을 초과 할 수 없습니다.',
  M0034: '50/51매대(앤드/특매대)는 등록상품수를 합산하여 \n200개 이상 등록 불가합니다.',
  M0035: '89매대는 등록상품수를 합산하여 200개 이상 등록 불가합니다.',
  M0036: '카테고리를 먼저 선택하세요.',
  M0037: '매대를 먼저 선택하세요.',
  M0038: '이미 등록된 상품이 있습니다.\n해당 상품으로 이동하시겠습니까?',
  M0039: '등록중인 동일한 상품이 있습니다.\n해당 상품으로 이동하시겠습니까?',
  M0040: '서버에 이미 저장된 상품입니다. \n조회 후 수정하시거나, 등록팝업에서 상품 스캔 후 수정하세요.'
}

export const ainvLang = {
  /* 폐기 */
  M0001: '요청사유를 입력하세요.',
  M0002: '종료일자는 시작일자 이후여야 합니다.',
  M0003: '점포에 등록되지 않은 상품입니다.\n확인 후 등록 부탁드립니다.',
  M0004: '특B상품은 입력할 수 없습니다.',
  M0005: '폐기등록 최대원가금액은 아이템당 일 ±100만원을 초과할 수 없습니다.',
  M0006: '폐기수량이 1,000개를 초과하였습니다.\n등록하시겠습니까?',
  M0007: '폐기등록 원가금액이 ±10만원을 초과하였습니다.\n등록하시겠습니까?',
  M0008: '팩코드는 등록 불가능합니다.',
  M0009: '폐기일자는 오늘 날짜만 가능 합니다.',
  M0010: '불용재고수량은 폐기수량보다 클수 없습니다.',
  M0011: '불용재고 최대수량을 초과 하였습니다.',
  M0073:
    '저장 여부를 알수없는 상품이 존재합니다. 폐기내역조회 메뉴를 통해 확인 후 이미 등록된 상품일 경우 삭제해 주세요.',
  M0074: '총 @건 마스터 데이터가 다운로드 완료되었습니다. 오프라인 모드로 폐기 등록업무를 진행해주세요.',
  M0075: '폐기 등록에 필요한 마스터 데이터를 다운로드 중입니다. 잠시만 기다려 주세요.',
  M0087:
    '폐기 저장 중 정상 저장여부를 알수 없는 데이터가 존재합니다.\n PC 또는 모바일 폐기등록 메뉴에서 저장여부를 꼭 확인하세요.\n ※ 이미 저장이 완료된 데이터는 중복 등록될 위험이 있습니다. 모바일 등록화면에서 등록중인 데이터를 삭제해 주세요.',
  M0088: '폐기 수량을 입력하세요.',
  M0089: '등록시 폐기일자는 오늘 날짜만 가능합니다.\n오늘날짜로 변경하시겠습니까?',
  M0091: '폐기 오프라인업무를 진행하기위해 마스터데이터를 다운로드 하세요.',
  M0094: '오늘 이전 마스터 데이터와 등록중인 폐기상품은 삭제됩니다.',
  M0095: '여러 대분류를 함께 다운로드시 시간이 오래걸릴 수 있습니다. 진행하시겠습니까?',

  /* 정기재고조사  */
  M0013: '재고조사 등록수량이 1,000개를 초과하였습니다.\n등록하시겠습니까?',
  M0014: '등록수량은 0보다 커야 합니다.',
  M0015: "삭제 가능한 상품이 없습니다.\n등록 저장한 상품의 삭제는 불가능합니다.'0'으로 수정하세요.",
  M0016: '특B 상품입니다. 등록불가능 상품입니다.',
  M0017: '재고조사 대상상품이 아닙니다.',
  M0018: '팩 상품입니다. 등록불가능 상품입니다.',
  M0019: "선택한 데이터를 정말 삭제하시겠습니까? \n등록 저장한 상품의 삭제는 불가능합니다.'0'으로 수정하세요.",
  M0020: '저장하시겠습니까?',
  M0021: '3개월 이내에 등록된 재고조사 일정이 없습니다.' /* 해당 날짜에 등록된 재고조사 일정이 없습니다. */,
  M0022: '재고조사 대상 대분류의 상품이 아닙니다.',
  //	M0023 : "재고조사 저장시간이 만료 되었습니다. \n저장 가능시간은 재고조사일 기준 당일 17시 부터 익일 12시 까지 입니다.",
  M0023: '재고조사 저장시간이 만료 되었습니다. \n저장 가능시간은 @ 부터 @ 까지 입니다.',
  M0024: '재고조사 일자를 먼저 선택하여 주십시오.',
  M0069: '조사구분는(은) 필수입력항목입니다.',
  M0070: '등록가능한 재고조사 일정이 없습니다.',
  M0071: '등록가능한 재고조사 일정을 선택하세요.',
  // M0072 : "재고조사 등록시간이 아닙니다. \n등록 가능시간은 @ 부터 @ 까지 입니다.",
  M0072: '재고조사 등록시간이 아닙니다. \n등록 가능시간은 대략 저녁 8시 입니다.',
  M0076: '총 @건 마스터 데이터가 다운로드 완료되었습니다. 오프라인 모드로 정기재고조사 등록업무를 진행해주세요.',
  M0077: '정기재고조사 등록에 필요한 마스터 데이터를 다운로드 중입니다. 잠시만 기다려 주세요.',
  M0078: '박스수량 또는 낱개수량을 입력하세요.',
  M0079: '다운로드할 대분류를 선택하세요.',
  M0080: '재고조사 등록시간이 아닙니다. \n대략 저녁 8시에 마스터 데이터를 다운로드하고 진행하세요.',
  M0081: '재고조사하실 재고조사명과 재고장소를 확인해 주세요.',
  M0082: '총 @건 저장이 완료 되었습니다.',
  M0083: '마스터 데이터 다운로드가 실패하였습니다. 관리자에게 문의 바랍니다.',
  M0084: '서버에 접속할수 없습니다. 인터넷 접속이 가능한 위치에서 마스터 파일 다운로드를 실행해 주세요.',
  M0085: '마스터 다운로드에 실패했습니다. 다시 시도하세요.',
  M0086:
    '정기재고조사 저장 중 정상 저장여부를 알수 없는 데이터가 존재합니다.\n PC 또는 모바일에서 정기재고조사내역 및 저장여부를 꼭 확인하세요.\n ※ 이미 저장이 완료된 데이터는 중복 등록될 위험이 있습니다. 모바일 등록화면에서 등록중인 데이터를 삭제해 주세요.',
  M0090: '등록시 폐기일자는 오늘 날짜만 가능합니다.\n오늘날짜로 변경하시겠습니까?',
  M0092:
    '현재 인터넷이 끊긴 상태입니다.\n인터넷이 연결되면 저장이 가능합니다.\n인터넷 연결이 가능한 위치로 이동하시고 다시 시도하세요.',
  M0093: '저장되지 않은, 등록중인 데이터 @건이 화면 목록에 표시 됩니다. 수량을 확인 하세요.',
  M0096: '변경하신 수량은 화면목록에서 저장하셔야 서버에 최종 반영 됩니다.',
  M0097: '정기재고조사 오프라인업무를 진행하기위해 마스터 데이터를 다운로드 하세요.',
  M0098: '마스터 다운로드가 취소되어 저장되어있던 마스터 데이터를 삭제중입니다. 잠시만 기다려주세요.',

  /* 영업중재고조사  201843C */
  M2001: '영업중재고조사 등록가능 시간이 아닙니다. \n재고조사 등록가능 시간은 @ 부터 @ 까지 입니다.',
  M2002: '※ 수량변경 시 해당상품의 재고변동내역이 삭제됩니다.',
  M2003: '  재고변동내역: 점간이동/폐기/사은품지급/자가소비/매출',

  /* 단품재고조정 */
  M1001: '등록시 재고조사일자는 시작일과 종료일이 오늘 날짜만 가능합니다.\n오늘날짜로 변경하시겠습니까?.',
  M1002: '일자가 날짜형식(YYYY-MM-DD)에 맞지 않습니다. 확인해주십시오.',
  M1003: '시작일이 종료일보다 클수 없습니다.',
  M1004: '대분류,카테고리를 선택하거나 상품을 입력후 조회 가능합니다.',
  M1005: '대분류,카테고리를 선택후 조회 가능합니다.',
  M1006: '재고기준의 수량을 입력하세요.',
  M1007: '팩코드는 등록불가능합니다.',
  M1008: '특B상품은 입력할 수 없습니다.',
  M1009: "농축수조리(매가환원법)는 '농축수산실재고조사등록' 화면을\n활용하시기 바랍니다.",
  M1010: '재고조사 대상 대분류 상품입니다.',
  M1011: '단품재고조정 LOSS최대금액은 아이템당 일 ±1000만원을 \n초과할 수 없습니다.',
  M1012: '사유는 필수입력입니다.',
  M1013: '(-)수량은 입력할수 없습니다.',
  M1014: '숫자만 입력가능합니다.',
  M1015: '등록중인 내용이 취소됩니다. 팝업창을 닫으시겠습니까?',
  M1016: '조회된 결과가 없습니다.',
  M0027: '최종적으로 LOSS누계수량이 반영됩니다.\nLOSS누계수량 및 LOSS금액을 확인하시기 바랍니다.\n저장하시겠습니까?',
  M0028: '점포에 등록되지 않은 상품입니다. 확인 후 등록 부탁드립니다.',
  M0029: '현재고는 약 5초후에 반영됩니다.\n화면 재조회 후 확인하세요!',
  M0030: '박스 수량이나 낱개 수량을 입력하세요.',
  M0031: '대분류,상품중 하나이상 입력후 조회가능합니다.',
  /* 가맹점발주재고조정 */
  M1017: '대분류,카테고리를 선택하거나 상품을 입력후 조회 가능합니다.',
  M1018: '대분류,카테고리를 선택후 조회 가능합니다.',
  M1019: '현재고 수량을 입력하세요.',
  M1020: '점포 미취급상품은 등록 할 수 없습니다(전일 수불장기준)',
  M1021: '삭제할 상품을 선택해주세요.',
  M1022: '환산수량이 1,000개 이상 입니다. 확인 부탁 드립니다.',
  M1023: '필수값이 입력되지 않았습니다. \n입력중인 정보가 등록되지 않습니다. \n계속 진행 하시겠습니까?',
  M1024: '필수값을 입력하세요.',
  M1025: '이미 등록된 상품이 있습니다.\n해당 상품으로 이동하시겠습니까?',
  M1026: '이미등록한 상품입니다.',
  M1027: '등록중인 동일한 상품이 있습니다.\n해당 상품으로 이동하시겠습니까?',
  M1028: '서버에 이미 저장된 상품입니다. \n조회 후 수정하시거나, 등록팝업에서 상품 스캔 후 수정하세요.',
  M1029: '',
  M1030: '',
  M0032: '저장하시겠습니까?',
  M0033: '삭제하시겠습니까?',
  M0034: '삭제가 완료되었습니다.',
  /* 결품조사 */
  M0035: '점포에 등록되지 않은 상품입니다.확인 후 등록 부탁드립니다.',
  M0036: '점포 미취급상품은 등록 할 수 없습니다(전일 수불장기준).',
  M0037: '결품조사등록 LOSS최대금액은 아이템당 일 ±1000만원을 \n초과할 수 없습니다.',
  M0038: '점포에 등록되지 않은 상품입니다.확인 후 등록 부탁드립니다.',
  M0039: "점포 미취급상품은 등록 할 수 없습니다(전일 수불장기준).'",
  M0040: '조사일자는 시작일과 종료일이 오늘 날짜만 가능합니다.',
  M0041: '저장이 완료되었습니다.',
  M0042: '한번 사유등록 저장하신 내역은 다시 사유없음으로 변경 저장할수 없습니다.',
  /* 클래스재고조사 */
  M0043: '소분류재고조정 등록수량이 1,000개를 초과하였습니다.\n등록하시겠습니까?',
  M0044: '재고조사 대상 대분류 포함 소분류입니다.',
  M0045: '재고조사 대상 소분류 상품이 아닙니다.',
  M0046: '팩코드는 등록 불가능합니다.',
  M0047: '재고조사 대상 대분류 상품입니다.',
  M0048: '대상소분류상품이 없습니다.',
  /* 불용재고조사 */
  M0012: '불용재고 등록은 오늘 날짜만 가능 합니다.',
  M0049: '저장하시겠습니까?',
  M0050: '성공적으로 저장하였습니다.',
  M0051: '삭제하시겠습니까? *삭제 후 저장을 해야 반영됩니다.',
  M0052: '삭제되었습니다.',
  M0053: '삭제할 내용이 없습니다.',
  M0054: '저장하시겠습니까?',
  M0055: '성공적으로 저장하였습니다.',
  M0056: '삭제할 내용이 없습니다.',
  M0057: '삭제하시겠습니까?',
  M0058: '삭제되었습니다.',
  M0070: '불용재고 등록은 오늘 날짜만 가능 합니다.\n오늘로 이동하시겠습니까?',

  /* 반품관리 */
  M0059: '수량을 입력하세요.',
  M0060: '팩 상품은 반품 불가능합니다.',
  M0061: '센터 휴무일에는 반품 불가능합니다.',
  M0062: '환산수량이 1000개를 초과했습니다.등록하시겠습니까?\nEnter 입력시 취소됩니다.',
  M0063: '[축산물 이력제] 대상 상품은 이력(묶음)번호를 입력하셔야 됩니다.',
  M0064: '[축산물 이력제] 대상 상품의 이력(묶음)번호는 숫자만 입력하셔야 됩니다.',
  M0065: '[축산물 이력제] 대상 상품의 이력(묶음)번호는 14 자리까지만 입력하셔야 됩니다.',
  M0066: '반품구분이 센터의 경우는 반품일자가 D+1이후만 가능하고\n협력사의 경우는 D일 이후만 가능합니다.',
  M0067: '수량을 입력하세요.',
  M0068: '환산수량이 1000개를 초과했습니다.등록하시겠습니까?',
  /* 점간이동 */
  M0101: '점간이동일자는 오늘 날짜만 가능 합니다.',
  M0102: '점간이동 수량이 1000개를 초과하였습니다.\n등록하시겠습니까?'
}

/**
 * 할인스티커 발행 관련 msg
 */
export const aprcLang = {
  /* base */
  M0001: '선택된 프린터가 없습니다.',
  M0002: '총 @건의 상품을 선택하셨습니다.\n발행하시겠습니까?',
  M0003: '인쇄를 완료하였습니다.',
  M0004: '저장하지 않은 상품이 있습니다. \n저장 후 발행이 가능합니다.',
  /* port open check */
  M0101: 'PORT OPEN에 실패하였습니다.\n확인바랍니다.',
  /* print status check */
  M0201: '프린터 상태 체크에 실패하였습니다. \n확인바랍니다.',
  M0202: '프린터 상태를 읽는데 실패하였습니다. \n확인바랍니다. (errCode : @)',
  M0203: '상품코드 [@] 출력 중 다음과 같은 문제가 생겼습니다.\n - 프린터와 연결이 끊어졌습니다. (errCode : @)',
  M0204: '상품코드 [@] 출력 중 다음과 같은 문제가 생겼습니다.\n - 용지가 없습니다. 용지를 보충해주세요. (errCode : @)',
  M0205:
    '상품코드 [@] 출력 중 다음과 같은 문제가 생겼습니다.\n - 프린터 투껑이 열려있습니다. 조치후 사용하세요. (errCode : @)',
  M0206: '상품코드 [@] 출력 중 다음과 같은 문제가 생겼습니다.\n - 전원이 부족합니다. 충전후 사용하세요. (errCode : @)',
  M0207:
    '상품코드 [@] 출력 중 다음과 같은 문제가 생겼습니다.\n - 알수 없는에러입니다. 관리자에게 문의하세요. (errCode : @)',
  /* data status check */
  M0301: '상품코드 [@] 할인스티커 발행수량을 확인하세요. (errCode : @)',
  M0399: '오류가 발생했습니다. \n관리자에게 문의하세요.(errCode : @)'
}

export const attachLang = {
  camera: '카메라',
  gallery: '갤러리'
}
export const ajbdhLang = {
  M0001: '사유를 작성하세요.'
}
export const ahpcLang = {
  M0001: '내용을 등록하세요.',
  M0002: '만족도 내역 입력',
  M0003: '접수유형을 선택해주세요.'
}
